<template>
  <div class="border-left border-right py-2 border-bottom">
    <div
      @click="details = !details"
      class="text-primary float-right py-2 text-center cursor-pointer"
      style="width: 50px;">
      <small>{{details ? '&#9650;' : '&#9660;'}}</small>
    </div>

    <div class="pl-4" style="margin-right: 50px;">
      <div>
        <a
          :href="getDrugFirstLink(prescription.drug)"
          target="_blank"
          class="">
          {{prescription.drug.name}}
          {{prescription.drug.measure || ''}}
          {{prescription.drug.measureUnit || ''}}
        </a>

        <small>
          {{ prescription.drug.manufacturer ? prescription.drug.manufacturer.name : ''}}
        </small>
      </div>

      <div>
        <small>
          {{ countPerPackage }} шт/уп, {{ packagesCount }} уп.
        </small>
      </div>

      <div v-show="details">
        <div class="pt-3">
          <div>
            <small class="font-weight-bold">Курс</small>
          </div>

          <div>
            {{prescription.duration}}
            {{declineNumber(prescription.duration, 'день')}}
            {{formatDate(prescription.startDate, 'd.m.y')}} -
            {{formatDate(prescription.finishDate, 'd.m.y')}}
          </div>

          <div>
            {{ prescription.quantity }}
            {{declineNumber(prescription.quantity, prescription.drug.format.name)}}
            {{ prescription.times.length }} р. в день
          </div>
        </div>

        <div class="pt-3">
          <div>
            <small class="font-weight-bold">Где купить</small>
          </div>

          <div
            v-for="stock in prescription.drug.stocks"
            :key="stock.id">
            <a
              :href="stock.link"
              target="blank">
              {{ stock.store.name }}
            </a>
          </div>
        </div>

        <div class="pt-3">
          <div>
            <small  class="font-weight-bold">
              Аналоги (в случае отсутствия основного препарата)
            </small>
          </div>

          <div v-if="prescription.drug.analogs.length > 0">
            <div
              v-for="analog in prescription.drug.analogs"
              :key="analog.id">
              <a
                :href="getDrugFirstLink(analog)"
                target="_blank"
                class="link">
                {{analog.name}}
                {{analog.measure || ''}}
                {{analog.measureUnit || ''}}
              </a>

              {{ analog.manufacturer ? analog.manufacturer.name : ''}}
            </div>
          </div>

          <div v-else>У этого препарата нет аналогов</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import formatDate from '../../../../utils/formatDate';
import calculateDaysCount from '../../../../utils/calculateDaysCount';
import declineNumber from '../../../../utils/declineNumber';
import {FORMAT_NAMES} from '../../../../constants';

export default {
  name: 'ClientDrugShoplistItem',

  props: ['prescription'],

  data() {
    return {
      details: false,
    };
  },

  computed: {
    totalCount() {
      const {startDate, finishDate, times, quantity} = this.prescription;
      const days = calculateDaysCount(startDate, finishDate);

      return days * times.length * quantity;
    },

    countPerPackage() {
      const packages = this.prescription.drug.packages.map(i => i.count);

      packages.sort((a, b) => a - b);

      for (const pack of packages) {
        if (pack >= this.totalCount) {
          return pack;
        }
      }

      return packages[packages.length - 1];
    },

    packagesCount() {
      return Math.ceil(this.totalCount / this.countPerPackage);
    },
  },

  methods: {
    getDrugFirstLink(drug) {
      for (const stock of drug.stocks) {
        if (typeof stock.link === 'string' && stock.link.trim() !== '') {
          return stock.link;
        }
      }

      return '';
    },

    formatDate(date, format) {
      return formatDate(new Date(date), format);
    },

    declineNumber(count, name) {
      const formatName = FORMAT_NAMES.find(i => i[0] === name);
      const [, few, one, two] = formatName || [name, name, name, name];

      return declineNumber(count, few, one, two);
    },

    async setBought(id) {
      try {
        await this.$store.dispatch('SET_BOUGHT_PRESCRIPTION', id);
      } catch (e) {
        await this.$store.dispatch('ERROR', e);
      }
    },

    async unsetBought(id) {
      try {
        await this.$store.dispatch('UNSET_BOUGHT_PRESCRIPTION', id);
      } catch (e) {
        await this.$store.dispatch('ERROR', e);
      }
    },
  }
};
</script>
